export const navbarItems = [
    {
        label: "Overview",
        type: "link",
        openInNewTab: false,
        activeLinks: ["/overview"],
        to: "/overview",
    },
    {
        label: "How It Works",
        type: "link",
        openInNewTab: false,
        activeLinks: ["/howitworks"],
        to: "/howitworks",
    },
];
